import { getUserProfile } from '@hrms/common/service/auth/utils';

const profile = getUserProfile();

export const USER_PREFERENCE_KEY = `hrms-userpreference-${profile?.email}`;
